import colors from "../../base/colors";

const { primary } = colors;

export default {
  styleOverrides: {
    root: {
      fontVariant: "all-small-caps",
      color: primary.main, 
    },
  },
};
